export default __webpack_public_path__ + "static/media/mainpageimage.b3c4e1a4.png";